/**
 * 経路詳細管理
 */
const state = {
  // 検索条件
  condition: null,
  // 経路情報
  routes: null,
  // 詳細用経路情報
  route: null,
  // 詳細の経路種別
  routeType: null,
  // ルートサマリ表示判定
  visibleSummary: false,
  // ルート詳細表示判定
  visibleDetail: false,
};

export { state as default };
